import { GiroWebappError } from 'model/error';
import { FindAllUserSeries } from 'model/series';
import { FindAllSeriesByUserActionTypes } from 'reducer/series/find-all-by-user/types';
import { action } from 'typesafe-actions';

export const findAllSeriesByUserRequest = () => action(FindAllSeriesByUserActionTypes.FIND_ALL_BY_USER_REQUEST);
export const findAllSeriesByUserSuccess = (response: ReadonlyArray<FindAllUserSeries>) => action(FindAllSeriesByUserActionTypes.FIND_ALL_BY_USER_SUCCESS, response);
export const findAllSeriesByUserError = (error: GiroWebappError) => action(FindAllSeriesByUserActionTypes.FIND_ALL_BY_USER_ERROR, error);
export const findAllSeriesByUserResetState = () => action(FindAllSeriesByUserActionTypes.FIND_ALL_BY_USER_RESET_STATE);
